import { render, staticRenderFns } from "./MirCashbackBadge.vue?vue&type=template&id=e16f5bde&scoped=true&"
import script from "./MirCashbackBadge.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MirCashbackBadge.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MirCashbackBadge.vue?vue&type=style&index=0&id=e16f5bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16f5bde",
  null
  
)

export default component.exports